export default [
  {
    title: "Select Spotlight Type",
    subtitle: "Choose the type of spotlight you want to add to your website.",
  },
  {
    title: "Add a Headline",
    subtitle: "The text your website visitors will see on your spotlight.",
  },
  {
    title: "Upload Audio",
    subtitle:
      "This audio file will play without leaving the page the user is on.",
  },
  {
    title: "Add a Custom Button",
    subtitle: "Add a call-to-action to convert visitors (or skip).",
  },
  {
    title: "Customize",
    subtitle: "Make your spotlight look and feel unique to your brand.",
  },
  {
    title: "Name Your Spotlight",
    subtitle: "This is for reference and will only be seen by you.",
  },
];
